import styled from 'styled-components';
import { INewProduct } from '../../../../interfaces/NewProduct.interfaces';
import { NewProductPreviewCardSwiper } from './NewProductPreviewCardSwiper';

interface NewProductPreviewCardSwiperWrapperProps {
  products: INewProduct[];
  title: string;
}

export const NewProductPreviewCardSwiperWrapper = ({ products, title }: NewProductPreviewCardSwiperWrapperProps) => {
  return (
    <Container>
      <ContentTitle>{title}</ContentTitle>

      <NewProductPreviewCardSwiper products={products} />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;

  padding: 40px 16px 0px 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  gap: 16px;
`;

const ContentTitle = styled.h3`
  width: 100%;

  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* System/XX-Large/xxl-bold */
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 85%; /* 17px */
`;
